import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AuthProvider } from './lib/auth-context';
import { AcceptInvitePage } from './pages/AcceptInvitePage';
import { ActivitiesPage } from './pages/ActivitiesPage';
import { AutomationEditorPage } from './pages/AutomationEditorPage';
import { AutomationsPage } from './pages/AutomationsPage';
import { BusinessDetailPage } from './pages/BusinessDetailPage';
import { ChatPage } from './pages/ChatPage';
import { CalendarPage } from './pages/CalendarPage';
import { HomePage } from './pages/HomePage';
import { KanbanPage } from './pages/KanbanPage';
import { LeadDetailPage } from './pages/LeadDetailPage';
import { LeadImportPage } from './pages/LeadImportPage';
import { LeadsPage } from './pages/LeadsPage';
import { LoginPage } from './pages/LoginPage';
import { MobilePage } from './pages/MobilePage';
import { TeamPage } from './pages/TeamPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { SalesPage } from './pages/sales/SalesPage';
import { SettingsPage } from './pages/settings/SettingsPage';

/** No celular, o início é "Meus leads"; no computador, o painel. */
function HomeOrMobile() {
  return window.matchMedia('(max-width: 767px)').matches ? (
    <Navigate to="/m" replace />
  ) : (
    <HomePage />
  );
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/convite/:token" element={<AcceptInvitePage />} />
            {/* Vendas: tela própria, pensada para o celular, sem o menu do CRM. */}
            <Route
              path="/vendas"
              element={
                <ProtectedRoute>
                  <SalesPage />
                </ProtectedRoute>
              }
            />
            {/* App do celular (Mobile1): leads por pipeline, sem o menu do CRM. */}
            <Route
              path="/m"
              element={
                <ProtectedRoute>
                  <MobilePage />
                </ProtectedRoute>
              }
            />
            {/* Equipe no celular (gestor): disponibilidade e fila. */}
            <Route
              path="/m/equipe"
              element={
                <ProtectedRoute>
                  <TeamPage mobile />
                </ProtectedRoute>
              }
            />
            <Route
              element={
                <ProtectedRoute>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route index element={<HomeOrMobile />} />
              <Route path="pipelines" element={<KanbanPage />} />
              <Route path="negocios/:id" element={<BusinessDetailPage />} />
              <Route path="leads" element={<LeadsPage />} />
              <Route path="leads/importar" element={<LeadImportPage />} />
              <Route path="leads/:id" element={<LeadDetailPage />} />
              <Route path="atividades" element={<ActivitiesPage />} />
              <Route path="calendario" element={<CalendarPage />} />
              <Route path="configuracoes" element={<SettingsPage />} />
              <Route path="configuracoes/:section" element={<SettingsPage />} />
              <Route path="automacoes" element={<AutomationsPage />} />
              <Route path="automacoes/:id" element={<AutomationEditorPage />} />
              <Route path="chat" element={<ChatPage />} />
              <Route path="notificacoes" element={<NotificationsPage />} />
              <Route path="equipe" element={<TeamPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
